import { Boxes } from 'lucide-react';
import { assetPrimaryLabel, type Asset, type Station } from '@hcc/types';

interface EquipmentPanelProps {
  station: Station;
  preAssigned: Asset[];
  selectedAssetIds: string[];
  onToggle: (asset: Asset) => void;
}

/**
 * Pre-assigned tracked assets for this person at this station, each with a
 * checkbox to include it in the issuance being recorded.
 */
export function EquipmentPanel({
  station,
  preAssigned,
  selectedAssetIds,
  onToggle,
}: EquipmentPanelProps) {
  return (
    <section
      aria-label={`${station} equipment`}
      className="rounded-token-lg border border-success/25 bg-success-soft/10 p-3"
    >
      <div className="flex items-center gap-1.5 text-sm font-semibold text-success-soft-fg">
        <Boxes className="h-4 w-4" />
        Pre-assigned {station} kit
      </div>

      <ul className="mt-2 space-y-1.5">
        {preAssigned.map((a) => {
          const checked = selectedAssetIds.includes(a.id);
          return (
            <li key={a.id}>
              <label
                className={`flex cursor-pointer items-center gap-2 rounded-token-sm border px-2 py-1.5 text-sm transition-colors ${
                  checked
                    ? 'border-success bg-success-soft/25'
                    : 'border-success/20 bg-surface hover:bg-success-soft/15'
                }`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => onToggle(a)}
                  className="h-4 w-4 accent-success"
                />
                <span className="font-mono text-xs font-medium text-fg">{assetPrimaryLabel(a)}</span>
                <span className="truncate text-xs text-fg-muted">{a.description}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
